import {
  Alert,
  Avatar,
  Box,
  Breadcrumbs,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { deepPurple, lightBlue } from '@mui/material/colors';
import { useCallback, useEffect, useState } from 'react';
import { useFindDetailBookByIds } from 'src/api/public/bookDetail';
import EmptyContent from 'src/components/empty-content';
import Iconify from 'src/components/iconify';
import TextMaxLine from 'src/components/text-max-line';
import { IMAGE_HOST_API } from 'src/config-global';
import { useResponsive } from 'src/hooks/use-responsive';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import GuestToolbox from '../_components/guest-toolbox';
import RegisterBorrowBookForm from '../_components/register-borrow-book-form/register-borrow-book-form';
import useBasket from '../_hooks/useBasket';
import { ButtonBorrowRegister, ButtonRemoveFromBasket } from '../_components/public-buttons';

export default function GioSach() {
  const {
    bookInStorage,
    baskets,
    setBaskets,
    removeFromBasket,
    removeManyFromBasket,
    handleRemoveNotFoundBooks,
  } = useBasket();
  const [bookSelected, setBookSelected] = useState<any>([]);
  const smUp = useResponsive('up', 'sm');
  const [bookBorrow, setBookBorrow] = useState<any>(null);
  const { data: basketData, isLoading } = useFindDetailBookByIds({
    unlimited: 1,
    ids: bookInStorage.toString(),
  });

  useEffect(() => {
    setBaskets([...basketData.data.list]);
  }, [basketData]);

  const handleRemoveBooks = useCallback(() => {
    handleBorrowSuccess(bookSelected);
  }, [bookSelected]);
  const handleBorrowBook = useCallback(
    (bookId: any) => {
      const borrow = baskets.find((book: any) => book.id === bookId);
      setBookBorrow({
        ids: [borrow.id],
        infors: [borrow],
      });
    },
    [baskets]
  );
  const handleBorrowBooks = useCallback(() => {
    const borrows = {
      ids: [] as any,
      infors: [] as any,
    };
    baskets.forEach((book: any) => {
      console.log(book, bookSelected);
      if (bookSelected.includes(book.id)) {
        borrows.ids.push(book.id);
        borrows.infors.push(book);
      }
    });
    setBookBorrow(borrows);
  }, [bookSelected]);
  const handleBorrowSuccess = useCallback(
    (ids: any[]) => {
      removeManyFromBasket(ids);
      setBookSelected([]);
    },
    [baskets]
  );

  const handleChangeBookSelected = useCallback(
    (isChecked: boolean, book: any) => {
      // console.log(event.target.checked, book, bookSelected);
      const newSelected = [...bookSelected];
      if (isChecked) {
        newSelected.push(book.id);
      } else {
        const position = newSelected.findIndex((b: any) => b === book.id);
        newSelected.splice(position, 1);
      }
      setBookSelected(newSelected);
    },
    [bookSelected, setBookSelected]
  );
  return (
    <>
      <GuestToolbox />
      <Breadcrumbs sx={{ mt: 2.5 }}>
        <Chip
          label="Tra cứu"
          component={RouterLink}
          href={paths.guest.tra_cuu}
          size="small"
          variant="soft"
          sx={{ cursor: 'pointer' }}
        />

        <Chip label="Giỏ ấn phẩm" size="small" variant="outlined" />
      </Breadcrumbs>
      {!isLoading && bookInStorage.length > baskets.length && (
        <Alert severity="warning" sx={{ width: 'fit-content', mx: 'auto' }}>
          Phát hiện {bookInStorage.length - baskets.length} ấn phẩm không tồn tại.
          <Typography
            component="span"
            sx={{
              textDecoration: 'underline',
              ml: 0.5,
              cursor: 'pointer',
              '&:hover': {
                color: 'red',
              },
              fontSize: 'inherit',
            }}
            color={deepPurple[400]}
            onClick={handleRemoveNotFoundBooks}
          >
            Xóa các ấn phẩm này
          </Typography>
        </Alert>
      )}
      {!isLoading && baskets?.length > 0 && (
        <>
          <Typography
            variant="h6"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              pl: { xs: 0, md: 2 },
            }}
            mt={0.5}
          >
            <Stack direction="row" alignItems="center">
              <Checkbox
                checked={bookSelected.length === bookInStorage.length}
                onChange={(event) => {
                  // console.log(event);
                  if (event.target.checked) {
                    setBookSelected([...bookInStorage]);
                  } else setBookSelected([]);
                }}
              />
              Giỏ ấn phẩm
            </Stack>

            {bookSelected.length > 0 && (
              <Tooltip title="Chọn 1 ấn phẩm để xóa" enterTouchDelay={200}>
                <Button
                  size={smUp ? 'medium' : 'small'}
                  startIcon={smUp && <Iconify icon="gg:remove" />}
                  color="error"
                  onClick={handleRemoveBooks}
                >
                  Xóa lựa chọn khỏi giỏ
                </Button>
              </Tooltip>
            )}
          </Typography>

          <List
            sx={{
              width: 1,
              overflowY: 'auto',
            }}
            disablePadding={!smUp}
          >
            {baskets?.map((book: any, index: number) => (
              <ListItem
                divider
                sx={{
                  width: 1,
                  flexShrink: 0,
                  ...(!smUp && {
                    px: 0,
                  }),
                }}
                key={book.id}
              >
                <Checkbox
                  checked={bookSelected.includes(book.id)}
                  sx={{ mr: 0 }}
                  onChange={(event) => {
                    handleChangeBookSelected(event.target.checked, book);
                  }}
                />
                <ListItemAvatar>
                  <Avatar
                    variant="square"
                    src={IMAGE_HOST_API + book.photoURL}
                    sx={{
                      aspectRatio: 1 / 1,
                      height: '100%',
                      width: '100%',
                      maxWidth: {
                        xs: 60,
                        md: 100,
                        lg: 150,
                      },
                    }}
                  />
                </ListItemAvatar>
                <ListItemText
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    height: '100%',
                    flexBasic: '100%',
                    position: 'relative',
                  }}
                  disableTypography
                >
                  <Link
                    sx={{
                      typography: {
                        xs: 'subtitle2',
                        md: 'h4',
                      },
                    }}
                    display="flex"
                    alignItems="center"
                    gap={0.5}
                    href={paths.guest.chi_tiet_sach(book.slug)}
                    component={RouterLink}
                  >
                    <TextMaxLine>{book.name}</TextMaxLine>
                    {smUp && (
                      <Iconify icon="fxemoji:openbook" sx={{ transform: 'rotate(10deg)' }} />
                    )}
                  </Link>
                  <Typography
                    sx={{
                      typography: {
                        xs: 'caption',
                        md: 'subtitle2',
                      },
                      fontWeight: {
                        xs: '600',
                        md: 'inherit',
                      },
                    }}
                  >
                    {book.author}.
                  </Typography>
                  <Chip
                    label={book.isReady ? 'Sẵn sàng' : 'Đang mượn'}
                    color={book.isReady ? 'success' : 'error'}
                    variant="soft"
                    size="small"
                  />
                </ListItemText>
                {smUp && (
                  <ListItemText sx={{ maxWidth: 150, flexShrink: 0 }}>
                    {book.isReady && (
                      <ButtonBorrowRegister onClick={() => handleBorrowBook(book.id)} />
                    )}

                    <ButtonRemoveFromBasket onClick={() => removeFromBasket(book.id)} />
                  </ListItemText>
                )}
              </ListItem>
            ))}
            <ListItem sx={{ mt: 1 }}>
              <Box ml="auto" alignItems="center" display="flex" gap={0.5}>
                <Tooltip title="Chọn ít nhất 1 ấn phẩm để đăng ký" placement="top">
                  <Iconify icon="heroicons:information-circle-solid" color={lightBlue[400]} />
                </Tooltip>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ width: 'fit-content' }}
                  onClick={handleBorrowBooks}
                  disabled={bookSelected.length === 0}
                >
                  Đăng kí mượn ấn phẩm
                </Button>
              </Box>
            </ListItem>
          </List>
          <RegisterBorrowBookForm
            open={!!bookBorrow}
            books={bookBorrow}
            onClose={() => setBookBorrow(null)}
            onSuccess={handleBorrowSuccess}
          />
        </>
      )}

      {isLoading && baskets?.length === 0 && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={4}
          sx={{ position: 'absolute', width: 1 }}
        >
          <CircularProgress size={80} />
        </Box>
      )}
      {!isLoading && baskets.length === 0 && (
        <EmptyContent
          title="Oop! Hiện chưa có ấn phẩm trong giỏ!"
          imgUrl="assets/icons/empty/ic_cart.svg"
        />
      )}
    </>
  );
}
